import { toString, Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { union_type, record_type, bool_type, class_type, tuple_type, string_type, list_type, int32_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { EntityType__get_DomainEntity, Entity_FromDomainEntity_Z6268B2B9, DomainEntity__get_Name, DomainEntity__get_Detail, Target__get_Name, DomainEntity_$reflection } from "../ClientTypes.fs.js";
import { Action_Category, DomainEntities_$reflection } from "../DomainEvents.fs.js";
import { choose as choose_1, tryHead, head, tail, contains, filter, length, cons, append, ofArray, map, singleton, isEmpty, empty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { Cmd_OfPromise_perform, Cmd_none, Cmd_batch } from "../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { targetEntity, many, single } from "../Api/Entities.fs.js";
import { choose } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { unwrap, bind, defaultArg, map as map_1, some } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { safeHash, createObj, equals, int32ToString } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { EPM_Domain_Events_DomainEntities__DomainEntities_ToProperString, EPM_Domain_Events_DomainEntities__DomainEntities_ToProperPluralString, Thoth_Fetch_FetchError__FetchError_get_Message } from "../Prelude.fs.js";
import { createElement } from "react";
import React from "react";
import { useFeliz_React__React_useOptionalFetch_Static_5B82200F, Fetched$1_toOption_50D43789 } from "../hooks/UseFetch.fs.js";
import { single as single_1 } from "../Api/Actions.fs.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/./UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Feliz.UseElmish.2.5.0/../Fable.Elmish.4.2.0/program.fs.js";
import { useFeliz_React__React_useInView_Static_13EC530 } from "../hooks/UseInView.fs.js";
import { Impl_createRemoveOptions, Impl_adjustPassive, Impl_defaultPassive } from "../fable_modules/Feliz.Listeners.1.1.0/./Listener.fs.js";
import { useEffect } from "../fable_modules/Feliz.2.9.0/./ReactInterop.js";
import { createDisposable, useCallbackRef } from "../fable_modules/Feliz.2.9.0/./Internal.fs.js";
import { useFeliz_React__React_useDebouncer_Static } from "../hooks/UseDebouncer.fs.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { empty as empty_1, singleton as singleton_1, append as append_1, delay as delay_1, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { Fa_ISize, Fa_IconOption, Fa_i } from "../fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";
import { join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { EPM_Domain_Events_Action_Category__Category_ToUrlString } from "../Api/../Prelude.fs.js";
import "./EntitySelector.scss";


class State extends Record {
    constructor(Offset, Fetch, Data, Selected, Query, Filters, EntityType, ProjectId, IsFetching, HasMore) {
        super();
        this.Offset = (Offset | 0);
        this.Fetch = (Fetch | 0);
        this.Data = Data;
        this.Selected = Selected;
        this.Query = Query;
        this.Filters = Filters;
        this.EntityType = EntityType;
        this.ProjectId = ProjectId;
        this.IsFetching = IsFetching;
        this.HasMore = HasMore;
    }
}

function State_$reflection() {
    return record_type("EPM.App.Components.EntitySelector.State", [], State, () => [["Offset", int32_type], ["Fetch", int32_type], ["Data", list_type(DomainEntity_$reflection())], ["Selected", list_type(DomainEntity_$reflection())], ["Query", string_type], ["Filters", list_type(tuple_type(string_type, string_type))], ["EntityType", DomainEntities_$reflection()], ["ProjectId", class_type("System.Guid")], ["IsFetching", bool_type], ["HasMore", bool_type]]);
}

class SelectMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SelectEntityIds", "SelectEntity", "ChangeEntity", "SelectEntities", "UnselectEntity", "UnselectAll", "QueryChange", "Fetch", "FetchNextPage", "Fetched", "FetchedNextPage", "NotifyExternal"];
    }
}

function SelectMsg_$reflection() {
    return union_type("EPM.App.Components.EntitySelector.SelectMsg", [], SelectMsg, () => [[["Item", list_type(class_type("System.Guid"))]], [["Item", DomainEntity_$reflection()]], [["Item", DomainEntity_$reflection()]], [["Item", list_type(DomainEntity_$reflection())]], [["Item", DomainEntity_$reflection()]], [], [["Item", string_type]], [], [], [["Item", list_type(DomainEntity_$reflection())]], [["Item", list_type(DomainEntity_$reflection())]], []]);
}

function init(projectId, entityType, initialEntities, filters) {
    return [new State(0, 25, empty(), empty(), "", filters, entityType, projectId, false, true), Cmd_batch(singleton(isEmpty(initialEntities) ? Cmd_none() : singleton((dispatch) => {
        dispatch(new SelectMsg(0, [initialEntities]));
    })))];
}

function fetchSelected(projectId, entityType, entityIds) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let pr;
        return ((pr = map((entityId) => single(entityType, projectId, entityId), entityIds), Promise.all(pr))).then((_arg) => (Promise.resolve(ofArray(choose((result) => {
            if (result.tag === 1) {
                console.error(some(result.fields[0]));
                return undefined;
            }
            else {
                return result.fields[0];
            }
        }, _arg)))));
    }));
}

function fetchEntities(projectId, entityType, filters, query, fetch$, offset) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        const apiParams = ofArray([["offset", int32ToString(offset)], ["fetch", int32ToString(fetch$)]]);
        const filterParams = append(filters, (entityType.tag === 6) ? singleton(["name", query]) : ((entityType.tag === 7) ? singleton(["name", query]) : ((entityType.tag === 8) ? singleton(["name", query]) : ((entityType.tag === 0) ? singleton(["name", query]) : ((entityType.tag === 14) ? singleton(["name", query]) : ((entityType.tag === 13) ? singleton(["name", query]) : ((entityType.tag === 1) ? singleton(["search", query]) : ((entityType.tag === 2) ? singleton(["search", query]) : ((entityType.tag === 9) ? singleton(["search", query]) : ((entityType.tag === 5) ? singleton(["search", query]) : ((entityType.tag === 4) ? singleton(["name", query]) : ((entityType.tag === 10) ? singleton(["name", query]) : ((entityType.tag === 11) ? singleton(["name", query]) : ((entityType.tag === 12) ? singleton(["name", query]) : singleton(["name", query])))))))))))))));
        return many(entityType, projectId, apiParams, filterParams).then((_arg) => {
            const entitiesFetched = _arg;
            if (entitiesFetched.tag === 1) {
                const error = entitiesFetched.fields[0];
                console.warn(some(Thoth_Fetch_FetchError__FetchError_get_Message(error)), error);
                return Promise.resolve(empty());
            }
            else {
                return Promise.resolve(entitiesFetched.fields[0]);
            }
        });
    }));
}

function update(onSelectedEntitiesChange, msg, state) {
    switch (msg.tag) {
        case 1:
            return [new State(state.Offset, state.Fetch, state.Data, cons(msg.fields[0], state.Selected), state.Query, state.Filters, state.EntityType, state.ProjectId, state.IsFetching, state.HasMore), singleton((dispatch) => {
                dispatch(new SelectMsg(11, []));
            })];
        case 2:
            return [new State(state.Offset, state.Fetch, state.Data, singleton(msg.fields[0]), state.Query, state.Filters, state.EntityType, state.ProjectId, state.IsFetching, state.HasMore), singleton((dispatch_1) => {
                dispatch_1(new SelectMsg(11, []));
            })];
        case 3:
            return [new State(state.Offset, state.Fetch, state.Data, append(state.Selected, msg.fields[0]), state.Query, state.Filters, state.EntityType, state.ProjectId, state.IsFetching, state.HasMore), singleton((dispatch_2) => {
                dispatch_2(new SelectMsg(11, []));
            })];
        case 6:
            return [new State(state.Offset, state.Fetch, state.Data, state.Selected, msg.fields[0], state.Filters, state.EntityType, state.ProjectId, state.IsFetching, state.HasMore), singleton((dispatch_3) => {
                dispatch_3(new SelectMsg(7, []));
            })];
        case 9: {
            const entities_2 = msg.fields[0];
            return [new State(state.Offset, state.Fetch, entities_2, state.Selected, state.Query, state.Filters, state.EntityType, state.ProjectId, false, !isEmpty(entities_2) ? true : ((length(entities_2) % state.Fetch) > 0)), Cmd_none()];
        }
        case 10: {
            const entities_3 = msg.fields[0];
            return [new State(state.Offset, state.Fetch, append(state.Data, entities_3), state.Selected, state.Query, state.Filters, state.EntityType, state.ProjectId, false, !isEmpty(entities_3) ? true : ((length(entities_3) % state.Fetch) > 0)), Cmd_none()];
        }
        case 7:
            return [new State(0, state.Fetch, state.Data, state.Selected, state.Query, state.Filters, state.EntityType, state.ProjectId, true, state.HasMore), Cmd_OfPromise_perform((offset) => fetchEntities(state.ProjectId, state.EntityType, state.Filters, state.Query, state.Fetch, offset), 0, (entities_4) => (new SelectMsg(9, [entities_4])))];
        case 8: {
            const offset_1 = (state.Offset + state.Fetch) | 0;
            return [new State(offset_1, state.Fetch, state.Data, state.Selected, state.Query, state.Filters, state.EntityType, state.ProjectId, true, state.HasMore), Cmd_OfPromise_perform((offset_2) => fetchEntities(state.ProjectId, state.EntityType, state.Filters, state.Query, state.Fetch, offset_2), offset_1, (entities_5) => (new SelectMsg(10, [entities_5])))];
        }
        case 11: {
            onSelectedEntitiesChange(state.Selected);
            return [state, Cmd_none()];
        }
        case 4:
            return [new State(state.Offset, state.Fetch, state.Data, filter((s_1) => !equals(s_1, msg.fields[0]), state.Selected), state.Query, state.Filters, state.EntityType, state.ProjectId, state.IsFetching, state.HasMore), singleton((dispatch_4) => {
                dispatch_4(new SelectMsg(11, []));
            })];
        case 5:
            return [new State(state.Offset, state.Fetch, state.Data, empty(), state.Query, state.Filters, state.EntityType, state.ProjectId, state.IsFetching, state.HasMore), Cmd_batch(ofArray([singleton((dispatch_5) => {
                dispatch_5(new SelectMsg(11, []));
            }), singleton((dispatch_6) => {
                dispatch_6(new SelectMsg(6, [""]));
            })]))];
        default:
            return [state, Cmd_OfPromise_perform((entityIds) => fetchSelected(state.ProjectId, state.EntityType, entityIds), msg.fields[0], (entities) => (new SelectMsg(3, [entities])))];
    }
}

function ActivityName(activityNameInputProps) {
    const activity = activityNameInputProps.activity;
    const projectId = activityNameInputProps.projectId;
    const actionOpt = Fetched$1_toOption_50D43789(useFeliz_React__React_useOptionalFetch_Static_5B82200F((actionId) => single_1(projectId, actionId), activity.ActionId, [activity.ActionId]));
    const target = useFeliz_React__React_useOptionalFetch_Static_5B82200F((tupledArg) => targetEntity(projectId, tupledArg[0], tupledArg[1]), map_1((te) => [te.EntityType, te.EntityId], activity.TargetEntity), [projectId, activity.TargetEntity]);
    const targetOpt = (target.tag === 2) ? target.fields[0] : undefined;
    const matchValue = activity.Name;
    let matchResult, action, action_1, target_1, activityName, target_2, activityName_1;
    if (actionOpt == null) {
        if (targetOpt == null) {
            if (matchValue != null) {
                matchResult = 3;
                activityName_1 = matchValue;
            }
            else {
                matchResult = 4;
            }
        }
        else if (matchValue != null) {
            matchResult = 2;
            activityName = matchValue;
            target_2 = targetOpt;
        }
        else {
            matchResult = 4;
        }
    }
    else if (targetOpt != null) {
        matchResult = 1;
        action_1 = actionOpt;
        target_1 = targetOpt;
    }
    else {
        matchResult = 0;
        action = actionOpt;
    }
    switch (matchResult) {
        case 0:
            return action.Name;
        case 1:
            return `${action_1.Name} (${Target__get_Name(target_1)})`;
        case 2:
            return `${activityName} (${Target__get_Name(target_2)})`;
        case 3:
            return `${activityName_1}`;
        default:
            return "?";
    }
}

function EntityName(entityNameInputProps) {
    const entity = entityNameInputProps.entity;
    const projectId = entityNameInputProps.projectId;
    if (entity.tag === 12) {
        return createElement(ActivityName, {
            projectId: projectId,
            activity: entity.fields[0],
        });
    }
    else {
        const matchValue = DomainEntity__get_Detail(entity);
        if (matchValue != null) {
            const detail = matchValue;
            return `${DomainEntity__get_Name(entity)} (${detail})`;
        }
        else {
            return DomainEntity__get_Name(entity);
        }
    }
}

export function DomainEntitiesSelector(domainEntitiesSelectorInputProps) {
    const isSmall = domainEntitiesSelectorInputProps.isSmall;
    const filters = domainEntitiesSelectorInputProps.filters;
    const onSelectedEntitiesChange = domainEntitiesSelectorInputProps.onSelectedEntitiesChange;
    const initialEntities = domainEntitiesSelectorInputProps.initialEntities;
    const entityType = domainEntitiesSelectorInputProps.entityType;
    const projectId = domainEntitiesSelectorInputProps.projectId;
    const patternInput = reactApi.useState(false);
    const showMenu = patternInput[0];
    const setShowMenu = patternInput[1];
    let patternInput_1;
    const init_1 = init(projectId, entityType, initialEntities, filters);
    patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init_1, (msg, state) => update(onSelectedEntitiesChange, msg, state), (_arg, _arg_1) => {
    }), undefined, [initialEntities, onSelectedEntitiesChange, toString(entityType)]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const patternInput_2 = useFeliz_React__React_useInView_Static_13EC530(undefined, undefined, undefined);
    const visibility = patternInput_2[1];
    const ref = reactApi.useRef(undefined);
    const closeMenu = reactApi.useCallback((_arg_2) => {
        setShowMenu(false);
    }, []);
    const elemRef = ref;
    const callback = closeMenu;
    const options_1 = defaultArg(undefined, Impl_defaultPassive);
    const action_1 = (ev) => {
        let copyOfStruct;
        const matchValue = elemRef.current;
        let matchResult, elem_1;
        if (matchValue != null) {
            if (!((copyOfStruct = matchValue, copyOfStruct.contains(ev.target)))) {
                matchResult = 0;
                elem_1 = matchValue;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                callback(ev);
                break;
            }
            case 1: {
                break;
            }
        }
    };
    const options_3 = options_1;
    let addOptions;
    const dependencies_1_2 = [options_3];
    addOptions = reactApi.useMemo(() => Impl_adjustPassive(options_3), dependencies_1_2);
    let removeOptions;
    const dependencies_1_3 = [options_3];
    removeOptions = reactApi.useMemo(() => Impl_createRemoveOptions(options_3), dependencies_1_3);
    let fn;
    const dependencies_1_4 = [action_1];
    fn = reactApi.useMemo(() => ((arg_1) => {
        action_1(arg_1);
    }), dependencies_1_4);
    useEffect(useCallbackRef(() => {
        if (addOptions == null) {
            document.addEventListener("mousedown", fn);
        }
        else {
            const options_1_1 = addOptions;
            document.addEventListener("mousedown", fn, options_1_1);
        }
        return createDisposable(() => {
            if (removeOptions == null) {
                document.removeEventListener("mousedown", fn);
            }
            else {
                const options_2_1 = removeOptions;
                document.removeEventListener("mousedown", fn, options_2_1);
            }
        });
    }));
    const action_3 = (ev_1) => {
        let copyOfStruct_1;
        const matchValue_1 = elemRef.current;
        let matchResult_1, elem_3;
        if (matchValue_1 != null) {
            if (!((copyOfStruct_1 = matchValue_1, copyOfStruct_1.contains(ev_1.target)))) {
                matchResult_1 = 0;
                elem_3 = matchValue_1;
            }
            else {
                matchResult_1 = 1;
            }
        }
        else {
            matchResult_1 = 1;
        }
        switch (matchResult_1) {
            case 0: {
                callback(ev_1);
                break;
            }
            case 1: {
                break;
            }
        }
    };
    const options_5 = options_1;
    let addOptions_1;
    const dependencies_1_5 = [options_5];
    addOptions_1 = reactApi.useMemo(() => Impl_adjustPassive(options_5), dependencies_1_5);
    let removeOptions_1;
    const dependencies_1_6 = [options_5];
    removeOptions_1 = reactApi.useMemo(() => Impl_createRemoveOptions(options_5), dependencies_1_6);
    let fn_1;
    const dependencies_1_7 = [action_3];
    fn_1 = reactApi.useMemo(() => ((arg_2) => {
        action_3(arg_2);
    }), dependencies_1_7);
    useEffect(useCallbackRef(() => {
        if (addOptions_1 == null) {
            document.addEventListener("touchstart", fn_1);
        }
        else {
            const options_1_2 = addOptions_1;
            document.addEventListener("touchstart", fn_1, options_1_2);
        }
        return createDisposable(() => {
            if (removeOptions_1 == null) {
                document.removeEventListener("touchstart", fn_1);
            }
            else {
                const options_2_2 = removeOptions_1;
                document.removeEventListener("touchstart", fn_1, options_2_2);
            }
        });
    }));
    const dependencies_9 = [visibility, state_1.IsFetching, state_1.HasMore];
    reactApi.useEffect(() => {
        switch (visibility) {
            case "partial":
            case "full": {
                if ((!state_1.IsFetching && state_1.HasMore) && (length(state_1.Data) > 0)) {
                    dispatch(new SelectMsg(8, []));
                }
                break;
            }
            default:
                undefined;
        }
    }, dependencies_9);
    const patternInput_3 = useFeliz_React__React_useDebouncer_Static("", (arg_3) => {
        dispatch(new SelectMsg(6, [arg_3]));
    }, 300);
    const currentValue = patternInput_3[0];
    const dropDownContent = isEmpty(state_1.Data) ? singleton(createElement("div", createObj(Helpers_combineClasses("dropdown-item", singleton(["children", "No results"]))))) : toList(delay_1(() => append_1(map((entity) => createElement("a", createObj(Helpers_combineClasses("dropdown-item", toList(delay_1(() => append_1(singleton_1(["children", createElement(EntityName, {
        projectId: projectId,
        entity: entity,
    })]), delay_1(() => (contains(entity, state_1.Selected, {
        Equals: equals,
        GetHashCode: safeHash,
    }) ? append_1(singleton_1(["className", "is-active"]), delay_1(() => singleton_1(["onClick", (e) => {
        e.preventDefault();
        dispatch(new SelectMsg(4, [entity]));
        closeMenu(e);
    }]))) : singleton_1(["onClick", (e_1) => {
        e_1.preventDefault();
        dispatch(new SelectMsg(1, [entity]));
        closeMenu(e_1);
    }]))))))))), state_1.Data), delay_1(() => {
        let show;
        return (show = (state_1.HasMore ? true : state_1.IsFetching), ofArray([createElement("hr", createObj(Helpers_combineClasses("dropdown-divider", toList(delay_1(() => (!show ? singleton_1(["className", "is-hidden"]) : empty_1())))))), createElement("div", createObj(Helpers_combineClasses("dropdown-item", toList(delay_1(() => append_1(!show ? singleton_1(["className", "is-hidden"]) : empty_1(), delay_1(() => {
            let iconProps, elems_1, elems;
            return singleton_1(["children", (iconProps = ofArray([["ref", patternInput_2[0]], ["className", "loading-spinner"], ["className", "is-small"], (elems_1 = [Fa_i(ofArray([new Fa_IconOption(11, ["fas fa-ellipsis-h"]), new Fa_IconOption(0, [new Fa_ISize(1, [])])]), [])], ["children", reactApi.Children.toArray(Array.from(elems_1))])]), createElement("span", createObj(ofArray([["className", "icon-text"], (elems = [createElement("span", createObj(Helpers_combineClasses("icon", toList(delay_1(() => iconProps))))), createElement("span", createObj(toList(delay_1(() => [["children", "loading"]]))))], ["children", reactApi.Children.toArray(Array.from(elems))])]))))]);
        })))))))]));
    }))));
    let text;
    const matchValue_3 = state_1.Selected;
    let matchResult_2, entity_1;
    if (showMenu) {
        matchResult_2 = 1;
    }
    else if (!isEmpty(matchValue_3)) {
        if (isEmpty(tail(matchValue_3))) {
            matchResult_2 = 0;
            entity_1 = head(matchValue_3);
        }
        else {
            matchResult_2 = 1;
        }
    }
    else {
        matchResult_2 = 1;
    }
    switch (matchResult_2) {
        case 0: {
            const matchValue_5 = DomainEntity__get_Detail(entity_1);
            if (matchValue_5 != null) {
                const detail = matchValue_5;
                text = (`${DomainEntity__get_Name(entity_1)} (${detail})`);
            }
            else {
                text = DomainEntity__get_Name(entity_1);
            }
            break;
        }
        default:
            text = currentValue;
    }
    return createElement("div", createObj(Helpers_combineClasses("dropdown", toList(delay_1(() => append_1(singleton_1(["className", join(" ", ["is-full-width", "entity-selector"])]), delay_1(() => append_1(singleton_1(["ref", ref]), delay_1(() => append_1(showMenu ? singleton_1(["className", "is-active"]) : empty_1(), delay_1(() => {
        let elems_5, elems_3;
        return singleton_1((elems_5 = [createElement("div", createObj(ofArray([["className", "tags-input"], (elems_3 = toList(delay_1(() => append_1(map((s) => {
            let elems_2;
            return createElement("span", createObj(Helpers_combineClasses("tag", ofArray([["className", "is-primary"], (elems_2 = toList(delay_1(() => {
                let matchValue_6;
                return append_1((matchValue_6 = s, (matchValue_6.tag === 12) ? singleton_1(createElement(ActivityName, {
                    projectId: projectId,
                    activity: matchValue_6.fields[0],
                })) : singleton_1(DomainEntity__get_Name(s))), delay_1(() => singleton_1(createElement("button", createObj(Helpers_combineClasses("delete", ofArray([["className", "is-small"], ["onClick", (_arg_3) => {
                    dispatch(new SelectMsg(4, [s]));
                }]])))))));
            })), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
        }, state_1.Selected), delay_1(() => singleton_1(createElement("input", createObj(cons(["type", "search"], Helpers_combineClasses("input", ofArray([["onFocus", (_arg_4) => {
            setShowMenu(true);
        }], ["onChange", (ev_2) => {
            patternInput_3[1](ev_2.target.value);
        }], ["value", currentValue], ["placeholder", `Choose ${EPM_Domain_Events_DomainEntities__DomainEntities_ToProperPluralString(state_1.EntityType)}`]])))))))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement("div", createObj(Helpers_combineClasses("dropdown-menu", singleton(["children", createElement("div", {
            className: "dropdown-content",
            children: reactApi.Children.toArray(Array.from(dropDownContent)),
        })]))))], ["children", reactApi.Children.toArray(Array.from(elems_5))]));
    })))))))))));
}

export function DomainEntitySelector(domainEntitySelectorInputProps) {
    const isSmall = domainEntitySelectorInputProps.isSmall;
    const filters = domainEntitySelectorInputProps.filters;
    const onSelectedEntityChange = domainEntitySelectorInputProps.onSelectedEntityChange;
    const initialEntity = domainEntitySelectorInputProps.initialEntity;
    const entityType = domainEntitySelectorInputProps.entityType;
    const projectId = domainEntitySelectorInputProps.projectId;
    let onSelectedEntitiesChange;
    const dependencies_1 = [onSelectedEntityChange];
    onSelectedEntitiesChange = reactApi.useCallback((arg) => {
        onSelectedEntityChange(tryHead(arg));
    }, dependencies_1);
    const patternInput = reactApi.useState(false);
    const showMenu = patternInput[0];
    const setShowMenu = patternInput[1];
    const patternInput_1 = useFeliz_React__React_useInView_Static_13EC530(undefined, undefined, undefined);
    const visibility = patternInput_1[1];
    const ref = reactApi.useRef(undefined);
    const closeMenu = reactApi.useCallback((_arg) => {
        setShowMenu(false);
    }, []);
    const elemRef = ref;
    const callback = closeMenu;
    const options_1 = defaultArg(undefined, Impl_defaultPassive);
    const action_1 = (ev) => {
        let copyOfStruct;
        const matchValue = elemRef.current;
        let matchResult, elem_1;
        if (matchValue != null) {
            if (!((copyOfStruct = matchValue, copyOfStruct.contains(ev.target)))) {
                matchResult = 0;
                elem_1 = matchValue;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                callback(ev);
                break;
            }
            case 1: {
                break;
            }
        }
    };
    const options_3 = options_1;
    let addOptions;
    const dependencies_1_2 = [options_3];
    addOptions = reactApi.useMemo(() => Impl_adjustPassive(options_3), dependencies_1_2);
    let removeOptions;
    const dependencies_1_3 = [options_3];
    removeOptions = reactApi.useMemo(() => Impl_createRemoveOptions(options_3), dependencies_1_3);
    let fn;
    const dependencies_1_4 = [action_1];
    fn = reactApi.useMemo(() => ((arg_2) => {
        action_1(arg_2);
    }), dependencies_1_4);
    useEffect(useCallbackRef(() => {
        if (addOptions == null) {
            document.addEventListener("mousedown", fn);
        }
        else {
            const options_1_1 = addOptions;
            document.addEventListener("mousedown", fn, options_1_1);
        }
        return createDisposable(() => {
            if (removeOptions == null) {
                document.removeEventListener("mousedown", fn);
            }
            else {
                const options_2_1 = removeOptions;
                document.removeEventListener("mousedown", fn, options_2_1);
            }
        });
    }));
    const action_3 = (ev_1) => {
        let copyOfStruct_1;
        const matchValue_1 = elemRef.current;
        let matchResult_1, elem_3;
        if (matchValue_1 != null) {
            if (!((copyOfStruct_1 = matchValue_1, copyOfStruct_1.contains(ev_1.target)))) {
                matchResult_1 = 0;
                elem_3 = matchValue_1;
            }
            else {
                matchResult_1 = 1;
            }
        }
        else {
            matchResult_1 = 1;
        }
        switch (matchResult_1) {
            case 0: {
                callback(ev_1);
                break;
            }
            case 1: {
                break;
            }
        }
    };
    const options_5 = options_1;
    let addOptions_1;
    const dependencies_1_5 = [options_5];
    addOptions_1 = reactApi.useMemo(() => Impl_adjustPassive(options_5), dependencies_1_5);
    let removeOptions_1;
    const dependencies_1_6 = [options_5];
    removeOptions_1 = reactApi.useMemo(() => Impl_createRemoveOptions(options_5), dependencies_1_6);
    let fn_1;
    const dependencies_1_7 = [action_3];
    fn_1 = reactApi.useMemo(() => ((arg_3) => {
        action_3(arg_3);
    }), dependencies_1_7);
    useEffect(useCallbackRef(() => {
        if (addOptions_1 == null) {
            document.addEventListener("touchstart", fn_1);
        }
        else {
            const options_1_2 = addOptions_1;
            document.addEventListener("touchstart", fn_1, options_1_2);
        }
        return createDisposable(() => {
            if (removeOptions_1 == null) {
                document.removeEventListener("touchstart", fn_1);
            }
            else {
                const options_2_2 = removeOptions_1;
                document.removeEventListener("touchstart", fn_1, options_2_2);
            }
        });
    }));
    let patternInput_2;
    const init_1 = init(projectId, entityType, choose_1((x) => x, singleton(initialEntity)), filters);
    patternInput_2 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init_1, (msg, state) => update(onSelectedEntitiesChange, msg, state), (_arg_1, _arg_1_1) => {
    }), undefined, [initialEntity, onSelectedEntityChange, toString(entityType)]);
    const state_1 = patternInput_2[0];
    const dispatch = patternInput_2[1];
    const dependencies_11 = [visibility, state_1.IsFetching, state_1.HasMore];
    reactApi.useEffect(() => {
        switch (visibility) {
            case "partial":
            case "full": {
                if ((!state_1.IsFetching && state_1.HasMore) && (length(state_1.Data) > 0)) {
                    dispatch(new SelectMsg(8, []));
                }
                else if ((!state_1.IsFetching && state_1.HasMore) && (length(state_1.Data) === 0)) {
                    dispatch(new SelectMsg(7, []));
                }
                break;
            }
            default:
                undefined;
        }
    }, dependencies_11);
    const patternInput_3 = useFeliz_React__React_useDebouncer_Static("", (arg_4) => {
        dispatch(new SelectMsg(6, [arg_4]));
    }, 300);
    const spinner = (show) => ofArray([createElement("hr", createObj(Helpers_combineClasses("dropdown-divider", toList(delay_1(() => (!show ? singleton_1(["className", "is-hidden"]) : empty_1())))))), createElement("div", createObj(Helpers_combineClasses("dropdown-item", toList(delay_1(() => append_1(!show ? singleton_1(["className", "is-hidden"]) : empty_1(), delay_1(() => {
        let iconProps, elems_1, elems;
        return singleton_1(["children", (iconProps = ofArray([["ref", patternInput_1[0]], ["className", "loading-spinner"], ["className", "is-small"], (elems_1 = [Fa_i(ofArray([new Fa_IconOption(11, ["fas fa-ellipsis-h"]), new Fa_IconOption(0, [new Fa_ISize(1, [])])]), [])], ["children", reactApi.Children.toArray(Array.from(elems_1))])]), createElement("span", createObj(ofArray([["className", "icon-text"], (elems = [createElement("span", createObj(Helpers_combineClasses("icon", toList(delay_1(() => iconProps))))), createElement("span", createObj(toList(delay_1(() => [["children", "loading"]]))))], ["children", reactApi.Children.toArray(Array.from(elems))])]))))]);
    })))))))]);
    const dropDownContent = isEmpty(state_1.Data) ? toList(delay_1(() => append_1(singleton_1(createElement("div", createObj(Helpers_combineClasses("dropdown-item", singleton(["children", "No results"]))))), delay_1(() => spinner(state_1.HasMore ? true : state_1.IsFetching))))) : toList(delay_1(() => append_1(map((entity) => createElement("a", createObj(Helpers_combineClasses("dropdown-item", toList(delay_1(() => {
        let matchValue_3, detail;
        return append_1((matchValue_3 = DomainEntity__get_Detail(entity), (matchValue_3 != null) ? ((detail = matchValue_3, singleton_1(["children", `${DomainEntity__get_Name(entity)} (${detail})`]))) : singleton_1(["children", DomainEntity__get_Name(entity)])), delay_1(() => (contains(entity, state_1.Selected, {
            Equals: equals,
            GetHashCode: safeHash,
        }) ? append_1(singleton_1(["className", "is-active"]), delay_1(() => singleton_1(["onClick", (e) => {
            e.preventDefault();
            dispatch(new SelectMsg(4, [entity]));
            closeMenu(e);
        }]))) : singleton_1(["onClick", (e_1) => {
            e_1.preventDefault();
            dispatch(new SelectMsg(2, [entity]));
            closeMenu(e_1);
        }]))));
    }))))), state_1.Data), delay_1(() => spinner(state_1.HasMore ? true : state_1.IsFetching)))));
    let text;
    const matchValue_4 = state_1.Selected;
    let matchResult_2, entity_1;
    if (showMenu) {
        matchResult_2 = 1;
    }
    else if (!isEmpty(matchValue_4)) {
        if (isEmpty(tail(matchValue_4))) {
            matchResult_2 = 0;
            entity_1 = head(matchValue_4);
        }
        else {
            matchResult_2 = 1;
        }
    }
    else {
        matchResult_2 = 1;
    }
    switch (matchResult_2) {
        case 0: {
            const matchValue_6 = DomainEntity__get_Detail(entity_1);
            if (matchValue_6 != null) {
                const detail_1 = matchValue_6;
                text = (`${DomainEntity__get_Name(entity_1)} (${detail_1})`);
            }
            else {
                text = DomainEntity__get_Name(entity_1);
            }
            break;
        }
        default:
            text = patternInput_3[0];
    }
    return createElement("div", createObj(Helpers_combineClasses("dropdown", toList(delay_1(() => append_1(singleton_1(["className", join(" ", ["is-full-width", "entity-selector"])]), delay_1(() => append_1(singleton_1(["ref", ref]), delay_1(() => append_1(showMenu ? singleton_1(["className", "is-active"]) : empty_1(), delay_1(() => {
        let elems_5, elems_3;
        return singleton_1((elems_5 = [createElement("div", createObj(Helpers_combineClasses("field", ofArray([["className", "has-addons"], (elems_3 = [createElement("div", createObj(Helpers_combineClasses("control", toList(delay_1(() => append_1(singleton_1(["className", "is-expanded"]), delay_1(() => append_1(isSmall ? singleton_1(["className", "is-small"]) : empty_1(), delay_1(() => singleton_1(["children", createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", toList(delay_1(() => append_1(isSmall ? singleton_1(["className", "is-small"]) : empty_1(), delay_1(() => append_1(singleton_1(["onFocus", (_arg_2) => {
            setShowMenu(true);
        }]), delay_1(() => append_1(singleton_1(["onChange", (ev_2) => {
            patternInput_3[1](ev_2.target.value);
        }]), delay_1(() => append_1(singleton_1(["value", text]), delay_1(() => singleton_1(["placeholder", `Choose ${EPM_Domain_Events_DomainEntities__DomainEntities_ToProperString(state_1.EntityType)}`])))))))))))))))])))))))))), createElement("div", createObj(Helpers_combineClasses("control", toList(delay_1(() => append_1(isSmall ? singleton_1(["className", "is-small"]) : empty_1(), delay_1(() => singleton_1(["children", createElement("button", createObj(Helpers_combineClasses("button", toList(delay_1(() => append_1(isSmall ? singleton_1(["className", "is-small"]) : empty_1(), delay_1(() => append_1(singleton_1(["className", "is-danger"]), delay_1(() => {
            let elems_2;
            return append_1(singleton_1((elems_2 = [Fa_i(singleton(new Fa_IconOption(11, ["fas fa-backspace"])), [])], ["children", reactApi.Children.toArray(Array.from(elems_2))])), delay_1(() => singleton_1(["onClick", (_arg_3) => {
                dispatch(new SelectMsg(5, []));
            }])));
        })))))))))]))))))))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), createElement("div", createObj(Helpers_combineClasses("dropdown-menu", singleton(["children", createElement("div", {
            className: "dropdown-content",
            children: reactApi.Children.toArray(Array.from(dropDownContent)),
        })]))))], ["children", reactApi.Children.toArray(Array.from(elems_5))]));
    })))))))))));
}

export function EntitySelector(entitySelectorInputProps) {
    const isSmall = entitySelectorInputProps.isSmall;
    const onSelectedEntityChange = entitySelectorInputProps.onSelectedEntityChange;
    const initialEntity = entitySelectorInputProps.initialEntity;
    const entityType = entitySelectorInputProps.entityType;
    const projectId = entitySelectorInputProps.projectId;
    let onChange;
    const dependencies_1 = [onSelectedEntityChange];
    onChange = reactApi.useCallback((e) => {
        onSelectedEntityChange(bind(Entity_FromDomainEntity_Z6268B2B9, e));
    }, dependencies_1);
    let filters;
    const dependencies_1_1 = [entityType];
    filters = reactApi.useMemo(() => {
        switch (entityType) {
            case "activity":
                return singleton(["actionCategory", EPM_Domain_Events_Action_Category__Category_ToUrlString(new Action_Category(0, []))]);
            case "documentTracking":
                return singleton(["actionCategory", EPM_Domain_Events_Action_Category__Category_ToUrlString(new Action_Category(3, []))]);
            case "certification":
                return singleton(["actionCategory", EPM_Domain_Events_Action_Category__Category_ToUrlString(new Action_Category(1, []))]);
            case "preservation":
                return singleton(["actionCategory", EPM_Domain_Events_Action_Category__Category_ToUrlString(new Action_Category(4, []))]);
            case "punchList":
                return singleton(["actionCategory", EPM_Domain_Events_Action_Category__Category_ToUrlString(new Action_Category(2, []))]);
            case "technicalQuery":
                return singleton(["actionCategory", EPM_Domain_Events_Action_Category__Category_ToUrlString(new Action_Category(5, []))]);
            default:
                return empty();
        }
    }, dependencies_1_1);
    return createElement(DomainEntitySelector, {
        projectId: projectId,
        entityType: EntityType__get_DomainEntity(entityType),
        initialEntity: unwrap(initialEntity),
        onSelectedEntityChange: onChange,
        filters: filters,
        isSmall: isSmall,
    });
}

